/**
 * StandBy — leave the set alone for a while and the station goes to a
 * "PLEASE STAND BY" card: accent-tinted colour bars, a slow clock, the
 * station ident. Any input snaps the picture back with a glitch.
 */
const IDLE_MS = 45_000;

export class StandBy {
  constructor({ background = null, idleMs = IDLE_MS } = {}) {
    this.bg = background;
    this.idleMs = idleMs;
    this.el = document.createElement('div');
    this.el.className = 'standby';
    this.el.setAttribute('aria-hidden', 'true');
    this.el.innerHTML = `
      <div class="standby__bars" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>
      <div class="standby__card">
        <p class="standby__pre">// we are experiencing technical difficulties</p>
        <h2 class="standby__title">Please stand by</h2>
        <p class="standby__meta"><span class="standby__ident">SB-TV · Portland, OR</span><span class="standby__clock">--:--:--</span></p>
        <p class="standby__hint">press any key to resume</p>
      </div>`;
    document.body.appendChild(this.el);
    this.shown = false;
    this._t = 0;
    this._clock = 0;
    const reset = () => this._reset();
    ['pointermove', 'pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach((ev) =>
      window.addEventListener(ev, reset, { passive: true }));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this._reset(); });
    this._arm();
  }

  _arm() {
    clearTimeout(this._t);
    if (document.hidden) return;
    this._t = setTimeout(() => this.show(), this.idleMs);
  }

  _reset() {
    if (this.shown) this.hide();
    this._arm();
  }

  show() {
    if (this.shown || document.body.classList.contains('is-world-open')) { this._arm(); return; }
    this.shown = true;
    this.el.classList.add('is-on');
    this.bg?.triggerGlitch?.({ intensity: 1.6 });
    const tickClock = () => {
      const d = new Date();
      this.el.querySelector('.standby__clock').textContent = d.toTimeString().slice(0, 8);
    };
    tickClock();
    this._clock = setInterval(tickClock, 1000);
  }

  hide() {
    this.shown = false;
    this.el.classList.remove('is-on');
    clearInterval(this._clock);
    this.bg?.triggerGlitch?.({ intensity: 2.2 });
  }
}
